import React, { useEffect, useRef, useState } from "react";
import Select, { components } from "react-select";
import "./customDropDown.scss";
import ClinicIcon from "../../../../assets/clinic_icon.svg";
import InfoIcon from "../../../../assets/info.png";
import Checked from "../../../../assets/editIcon.svg";
import { Modal, Button } from "react-bootstrap";

const CustomDropDown = ({
  options,
  placeholder,
  handleChange,
  handleBlur,
  customStyles,
  className,
  showSearch,
  isSearchable,
  noOptionsMessage,
  doctorRole,
  ...props
}) => {
  const [open, setOpen] = useState(false);

  const styles = {
    control: (base) => ({
      ...base,
      alignSelf: "center",
      width: "95% !important",
      // background: " #F5F6F7 0% 0% no-repeat padding-box",
      background: "none",
      boxShadow: "none",
      border: "none",
      cursor: "pointer",
      "&:hover": {
        boxShadow: "none",
      },
      height: 35,
      minHeight: 35,
    }),
    valueContainer: (base) => ({
      ...base,
      height: "40px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      "@media only screen and (max-width: 767px)": {
        height: "36px",
      },
    }),
    menu: (provided) => ({
      ...provided,
      marginTop: "19px",
      borderRadius: "0px",
    }),
    menuList: (provided) => ({
      ...provided,
      cursor: "pointer",
      maxHeight: "200px",
      paddingTop: "0px",
      // display: "flex",
      // flexDirection: "row",
      "&::-webkit-scrollbar": {
        width: "16px",
        height: " 16px",
        display: "block !important",
        background: "none",
      },
      "&::-webkit-scrollbar-track": {
        background: "none",
        borderRadius: "10px",
      },
      "&::-webkit-scrollbar-thumb": {
        boxShadow: "inset 0 0 16px rgba(240, 232, 232, 1)",
        minHeight: "60px !important",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "#888",
        border: "none",
      },
    }),
    indicatorsContainer: (base, data) => ({
      ...base,
      height:
        data?.selectProps?.value?.clinic_name == "My Clinic" ||
        data?.selectProps?.value?.clinic_locality === ""
          ? "100%"
          : "50%",
      "@media only screen and (max-width: 767px)": {
        height:
          data?.selectProps?.value?.clinic_name == "My Clinic" ||
          data?.selectProps?.value?.clinic_locality === ""
            ? "100%"
            : "45%",
      },
    }),
  };

  const groupStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    fontSize: "14px",
  };
  const formatGroupLabel = (data) => (
    <>
      <div style={groupStyles}>
        <span className="ml-1">{data.label}</span>
        <div>
          {data?.label === "C2C VIRTUAL CLINIC" ? (
            <img
              src={InfoIcon}
              style={{ width: 18, cursor: "pointer" }}
              alt=""
              onClick={onOpenModal}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => {
    setOpen(false);
  };

  const Option = (props) => {
    const { data, innerRef, innerProps } = props;
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          className="mx-3 py-2"
          ref={innerRef}
          {...innerProps}
          style={{
            width: "100%",
            cursor: "pointer",
            borderBottom:
              // data?.clinic_name === "My Clinic" ? "2px solid #D6DAE5" : "none",
              data.doctor_id === "" ? "2px solid #D6DAE5" : "none",
          }}
        >
          <div>
            <span style={{ fontSize: "1rem", textTransform: "capitalize" }}>
              {data?.clinic_name}
            </span>
          </div>

          <div style={{ color: "#A6ACB9" }}>
            <span
              className="my-1"
              style={{ fontSize: "12px", textTransform: "capitalize" }}
            >
              {data?.clinic_locality ? data?.clinic_locality : ""}
            </span>
          </div>
        </div>
      </div>
    );
  };
  const formatOptionLabel = (data, { context }) => {
    if (context === "value") {
      return (
        <>
          <div
            className="d-flex align-items-center justify-content-start"
            style={{
              height: "100%",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            <img
              src={ClinicIcon}
              alt="clinicIcon"
              style={{
                width: 20,
                marginTop: `${
                  data?.clinic_name !== "My Clinic" &&
                  data?.clinic_locality !== ""
                    ? "-20px"
                    : "0px"
                }`,
              }}
            />
            <div
              style={{
                padding: "10px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              <div>
                <span
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    textTransform: "capitalize",
                  }}
                >
                  {data?.clinic_name}
                </span>
                {/* <span className="ml-1"> - </span> */}
              </div>
              <div
                className="align-items-center justify-content-start"
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                <span
                  style={{
                    fontSize: "0.8rem",
                    color: "#A6ACB9",
                    textTransform: "capitalize",
                  }}
                >
                  {data?.clinic_locality ? data?.clinic_locality : ""}
                </span>
              </div>
            </div>
          </div>
        </>
      );
    }
  };

  const DropdownIndicator = (props) => {
    if (
      doctorRole !== "resource_administrator" &&
      doctorRole !== "resource_consultant"
    ) {
      return (
        components.DropdownIndicator && (
          <components.DropdownIndicator {...props}>
            {props.selectProps.menuIsOpen ? (
              <i
                className="fa fa-caret-up"
                style={{ color: "#000", marginLeft: "5px" }}
              ></i>
            ) : (
              <i
                className="fa fa-caret-down"
                style={{ color: "#000", marginLeft: "5px" }}
              ></i>
            )}
          </components.DropdownIndicator>
        )
      );
    } else {
      return null;
    }
  };
  return (
    <div
      className="d-flex w-100"
      style={{ minHeight: "60px !important", alignSelf: "center" }}
    >
      <Select
        className={`${className} selectContainer`}
        classNamePrefix="select"
        name="prescriptionSelector"
        formatOptionLabel={formatOptionLabel}
        styles={customStyles || styles}
        placeholder="Select Clinic"
        components={{
          Option,
          DropdownIndicator: DropdownIndicator,
          IndicatorSeparator: () => null,
        }}
        isSearchable={isSearchable}
        onChange={(opt) => {
          handleChange(opt);
        }}
        // options={options}
        options={
          doctorRole !== "resource_administrator" &&
          doctorRole !== "resource_consultant"
            ? options
            : ""
        }
        noOptionsMessage={() => noOptionsMessage || "No Result Found"}
        {...props}
        formatGroupLabel={formatGroupLabel}
        onMenuOpen={() => {
          props?.onMenuOpen && props.onMenuOpen(true);
        }}
        onMenuClose={() => {
          props?.onMenuOpen && props.onMenuOpen(false);
        }}
      />

      <Modal
        show={open}
        onHide={onCloseModal}
        backdrop="static"
        centered
        className={`info-modal ${!open ? "hide_modal" : ""}`}
      >
        <Modal.Body className="p-4" style={{ margin: "50px" }}>
          <div className="text-center align-items-center ">
            <img
              src={Checked}
              alt="clinicIcon"
              style={{
                // width: 20,
                marginBottom: "20px",
              }}
            />
            <h1 className="header-text">Edit Clinic Details</h1>
            <h2 className="edit-text">
              If you wish to update the “My Clinic” name and add location,
              please contact <span className="number-text">1800 267 9899</span>.
            </h2>
          </div>
          <div className="d-flex flex-column justify-content-center align-items-center">
            <Button
              className="custom-modal-button okay-button"
              style={{
                backgroundColor: "#17BAE0",
                color: "#fff",
                width: "150px",
                height: "50px",
              }}
              onClick={onCloseModal}
            >
              Okay
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CustomDropDown;
